import React from 'react';

type LoadingStateProps = {
  columns: string[];
  rowCount?: number;
  className?: string;
};

const LoadingState = ({
  columns,
  rowCount = 5,
  className = 'data-loading',
}: LoadingStateProps) => {
  return (
    <div className={className} aria-busy="true" aria-live="polite">
      <table className="thn-table data-table container-style">
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx} scope="col">{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rowCount }).map((_, i) => (
            <tr key={i} className="data-table__row--loading">
              {columns.map((_, j) => (
                <td key={j}>
                  <div className="skeleton skeleton-text" style={{ width: j === 0 ? '60%' : '40%' }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LoadingState;
